import { Icon } from "@evergis/ui";
import React, { ReactElement } from "react";
import styled from "styled-components";

import { Descr } from "../styled";
import { ImportType } from "../types";

const FileIcon = styled(Icon)`
  margin: 0 2px 0 2px;

  :after {
    color: ${({ theme: { palette } }) => palette.icon};
  }
`;

export const styledHeaderSubTitle = (fileName: string, importType: ImportType): ReactElement => (
  <Descr>
    <FileIcon kind={importType === ImportType.XLSX ? "geom_point" : "zip"} /> {fileName}
  </Descr>
);
